import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { FormProps } from './interfaces/form-props';
import Button from '../components/essence/button/button';
import { checkVisibilityCondition } from './utils/check-visibility-condition';
import InputFormField from '../components/essence/input/input-form-field';
import { EssenceDatePickerFormField } from '../components/essence/date-picker/date-picker-form-field';
export const DynamicForm = ({ ...props }: FormProps) => {
	const {
		initialValues,
		submitButtonType,
		submitButtonTitle,
		inputs,
		onSubmit,
		onFormStateChange,
		validationSchema,
		className,
		children,
	} = props;

	const formMethods = useForm({
		shouldFocusError: false,
		resolver: yupResolver(validationSchema),
		defaultValues: { ...initialValues },
	});

	useEffect(() => {
		if (onFormStateChange) {
			onFormStateChange(formMethods);
		}
	}, [formMethods, onFormStateChange]);

	const createInputs = () => {
		const formValues = formMethods.getValues();

		const filteredInputs = inputs.filter(input => {
			if (!input.visibleWhen) return true;

			let visible = true;
			for (const condition of input.visibleWhen) {
				if (!checkVisibilityCondition(condition, formValues)) {
					visible = false;
					break;
				}
			}

			return visible;
		});
		return filteredInputs.map(({ ...inputProps }) => {
			switch (inputProps.type) {
				case 'text':
					return (
						<InputFormField
							{...inputProps}
							key={inputProps.name}
							control={formMethods.control}
							error={formMethods.formState.errors[inputProps.name]}
						/>
					);
				case 'datepicker':
					return (
						<EssenceDatePickerFormField
							{...inputProps}
							key={inputProps.name}
							control={formMethods.control}
							error={formMethods.formState.errors[inputProps.name]}
						/>
					);
				default:
					return (
						<InputFormField
							{...inputProps}
							key={inputProps.name}
							control={formMethods.control}
							error={formMethods.formState.errors[inputProps.name]}
						/>
					);
			}
		});
	};

	return (
		<>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)} className={` ${className ?? ''}`}>
					{createInputs()}
					{children}
					{submitButtonType === 'Button' && (
						<Button
							type="submit"
							disabled={formMethods.formState.isSubmitting ? true : undefined}
							name={formMethods.formState.isSubmitting ? 'Saving...' : (submitButtonTitle ?? 'Save')}
						/>
					)}
				</form>
			</FormProvider>
		</>
	);
};
